export function sortWorkspacesAlphabeticallyAndReCOCFirstAndCOCSecond<T extends { title?: string }>(
  workspaces: T[],
): T[] {
  const titleIncludesReCOC = (title: string): boolean => title.toUpperCase().includes('RECOC');
  const titleIncludesOnlyCOC = (title: string): boolean =>
    title.toUpperCase().includes('COC') && !titleIncludesReCOC(title);

  const titleDescSort = (a: T, b: T) => {
    const aTitle = a.title ?? '',
      bTitle = b.title ?? '';

    if (titleIncludesReCOC(aTitle) && !titleIncludesReCOC(bTitle)) {
      return -1;
    }

    if (!titleIncludesReCOC(aTitle) && titleIncludesReCOC(bTitle)) {
      return 1;
    }

    if (titleIncludesOnlyCOC(aTitle) && !titleIncludesOnlyCOC(bTitle)) {
      return -1;
    }
    if (!titleIncludesOnlyCOC(aTitle) && titleIncludesOnlyCOC(bTitle)) {
      return 1;
    }

    return aTitle.localeCompare(bTitle);
  };

  return workspaces.sort(titleDescSort);
}

export function sortWorkspacesWithFeaturedFirst<T extends { id?: string; title?: string }>(
  workspaces: T[],
  featuredWorkspaceId: string | null,
) {
  const isFeatured = (id: string | undefined): boolean => id !== undefined && id === featuredWorkspaceId;

  const titleDescSort = (a: T, b: T) => {
    if (isFeatured(a.id)) {
      return -1;
    }

    if (isFeatured(b.id)) {
      return 1;
    }

    // untitled workspaces sort last
    if (a.title === undefined) {
      return b.title === undefined ? 0 : 1;
    }
    if (b.title === undefined) {
      return -1;
    }

    return a.title.localeCompare(b.title);
  };

  // if workspaces come from the query, they are readonly
  return [...workspaces].sort(titleDescSort);
}
